import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";

const RouterContext = createContext(null);

export function RouterProvider({ children }) {
  const { user } = useAuth();
  const [routers, setRouters] = useState([]);
  const [selected, setSelectedState] = useState(() => localStorage.getItem("fasnet_router") || "");

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/routers");
      setRouters(data);
      return data;
    } catch (e) {
      return [];
    }
  }, []);

  const userId = user?.id;
  useEffect(() => {
    if (userId) refresh();
  }, [userId, refresh]); // hanya saat login/ganti akun — bukan tiap refreshUser (60 dtk) yang membuat objek user baru

  useEffect(() => {
    if (routers.length && !routers.find((r) => r.id === selected)) {
      setSelectedState(routers[0].id);
    }
  }, [routers, selected]);

  const setSelected = useCallback((id) => {
    localStorage.setItem("fasnet_router", id);
    setSelectedState(id);
  }, []);

  const router = routers.find((r) => r.id === selected) || null;

  return (
    <RouterContext.Provider value={{ routers, router, selected, setSelected, refresh }}>
      {children}
    </RouterContext.Provider>
  );
}

export const useRouters = () => useContext(RouterContext);
